module.exports = "<div class=\"spinner-border\" role=\"status\">\n    <span class=\"sr-only\">Loading...</span>\n</div>"